
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.707.28a1.035 1.035 0 00-1.414 0L6.313 11.698l-4.606-4.39a1.035 1.035 0 00-1.414 0 .922.922 0 000 1.348l5.312 5.064c.39.372 1.024.372 1.414 0L19.707 1.627a.922.922 0 000-1.348z","fill":"currentColor"}})])
          )
        }
      }
    